<template>
  <div>
    <HSelect
      :options="options"
      :value="status"
      option-key="label"
      option-label="label"
      name="select-status"
      :disabled="disabled"
      @update:value="handleChangeStatus"
    >
      <template #iconLeft>
        <span
          class="user-status__circle"
          :class="[`user-status__circle--${currentStatus}`]"
        ></span>
      </template>
      <template #options="{ option }">
        <div class="user-status__item">
          <div class="user-status__item__icon">
            <WIcon :icon="icons[option.value]" size="medium" />
          </div>
          <div class="user-status__item__label">
            {{ option.label }}
          </div>
          <div class="user-status__item__description">
            {{ option.description }}
          </div>
        </div>
      </template>
    </HSelect>
    <div class="user-status__description">{{ description }}</div>
  </div>
</template>
<script>
import { WIcon } from '@alice-health/wonderland-vue'

import { HSelect } from '@/components/shared/atoms'
import { STAFF_STATUS, STAFF_STATUS_OPTIONS } from '@/models/channels'
export default {
  components: { WIcon, HSelect },
  props: {
    currentStatus: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ['input'],
  data() {
    return {
      status: null,
      options: [...STAFF_STATUS_OPTIONS],
      icons: {
        [STAFF_STATUS.AVAILABLE]: 'icChat',
        [STAFF_STATUS.BUSY]: 'icClock',
        [STAFF_STATUS.UNAVAILABLE]: 'icBlock'
      }
    }
  },
  computed: {
    description() {
      return this.getOptionValue(this.currentStatus)?.description
    }
  },
  watch: {
    currentStatus: {
      handler: 'setCurrentStatus',
      immediate: true
    }
  },
  methods: {
    handleChangeStatus(status) {
      this.$emit('input', status.value)
    },
    getOptionValue(currentStatus) {
      return this.options.find(status => status.value === currentStatus)
    },
    setCurrentStatus(currentStatus) {
      const currentValue = this.getOptionValue(currentStatus)
      this.status = currentValue
    }
  }
}
</script>
<style lang="scss" scoped>
.user-status {
  &__circle {
    border-radius: 100%;
    width: 10px;
    height: 10px;

    &--AVAILABLE {
      background-color: var(--sys-color-content-success);
    }
    &--BUSY {
      background-color: var(--gl-color-shades-yellow-60);
    }
    &--UNAVAILABLE {
      background-color: var(--sys-color-content-error);
    }
  }
  &__description {
    margin-top: var(--gl-spacing-02);
    font-weight: var(--gl-font-weight-light);
    font-size: var(--gl-font-size-xxs);
    color: var(--gl-color-shades-gray-100);
    max-width: 255px;
  }
  &__item {
    display: grid;
    align-items: center;
    gap: var(--gl-spacing-02);
    grid-template-columns: 15px auto;
    grid-template-areas:
      'icon label'
      'description description';
    &__icon {
      grid-area: icon;
      align-items: center;
      display: flex;
    }
    &__label {
      grid-area: label;
      align-items: center;
      display: flex;
      font-weight: var(--gl-font-weight-semibold);
      font-size: var(--gl-font-size-xxs);
      letter-spacing: var(--gl-letter-spacing-rule-02);
    }
    &__description {
      grid-area: description;
      font-size: var(--gl-font-size-xxs);
    }
  }
}
</style>
